<template>
    <div>
        <audio src="@/assets/auto/iphoneWeChat.mp3" :muted="muted" preload="auto" class="audio" id="audioAuto"></audio>
        <audio src="@/assets/auto/gift.mp3" :muted="muted" preload="auto" class="audio" id="giftAudio"></audio>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {

        };
    },
    computed: {
        muted() {
            return this.$store.state.muted
        }
    },
    watch: {

    },
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.audio {
    position: fixed;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
}
</style>